export const notifications = {
  successDataUpdate: 'Данные успешно изменены.',
  errorOnDataUpdate: 'При изменении данных произошла ошибка.',
  waitResponseIn24Hours:
    'Ожидайте ответ на ваше приглашение в течении 72 часов.',
  workItemIsCanceled: 'Приглашение было отозвано',
  notificationDeleted: 'Уведомление удалено',
  noNotifications: 'У вас нет уведомлений',
  workInviteRejected: 'Приглашение отклонено',
  workStartOnArtistArrivalConfirm:
    ' Работа начнётся с момента, когда клуб подтвердит ваше присутствие на рабочем месте.',
  giveResponseFormWorkItem:
    'Дайте ответ на приглашение в течении 72 часов. После 72 часов приглашение будет удалено.',
  generalError: 'Что-то пошло не так, попробуйте позже.',
  passwordReseted: 'Пароль сброшен',
  languageSwitched: 'Язык изменен',
  invitationExpired: 'Срок действия приглашения истек',
  linkIsCopied: 'Ссылка скопирована',
  accountIsVisible: 'Аккаунт будет показан в поиске',
  hiringEnabled: 'Набор артистов открыт',
  hiringDisabled: 'Набор артистов закрыт',
  rejectedForReason: 'Oтклонено по причине {content}',
  profileDeleted: 'Профиль удален',
  accountHiddenFromSearch:
    'Аккаунт скрыт и больше не отображется в поиске у артистов',
  registerRequestSended: 'Запрос на регистрацию отправлен',
  notFoundNotifications: 'У вас нет уведомлений',
  lastWorkDaySeted: 'Установлена ​​последняя дата работы'
};
